import { InitialValues } from 'forms/types';

import { ApplicationFormValues } from '../form/types';
import { readEmailFromCache } from '../storage';

const normalizeUSPhone = (raw?: string): string => {
  if (!raw) {
    return '';
  }
  const digits = raw.replace(/\D/g, '');
  const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  return national.length === 10 ? national : '';
};

const buildInitialValues = (
  data: Partial<ApplicationFormValues>
): InitialValues<ApplicationFormValues> => {
  const emailFromCache = typeof window !== 'undefined' ? readEmailFromCache() : undefined;
  const normalizedPhone = normalizeUSPhone(data.phoneNumber);

  return {
    firstName: data.firstName ?? '',
    lastName: data.lastName ?? '',
    email: data.email ?? emailFromCache ?? '',
    phoneType: data.phoneType ?? '',
    phoneNumber: normalizedPhone,
  };
};

export default buildInitialValues;
